import errorManager from '@/rollbar.js';
const initRoomBedsResult = (item) => {
  if (item.loading) return item.text;

  const taglie = ['(XS)', '(S)', '(M)', '(L)', '(XL)', '(XXL)'];
  if (item.taglia > 0 && item.taglia <= taglie.length) {
    return `${item.description.toUpperCase()} ${taglie[item.taglia - 1]}`;
  } else {
    if (item.hasOwnProperty('description')) {
      return item.description.toUpperCase();
    } else {
      return i18nJS.clic_per_selezionare;
    }
  }
};

const sizeSelect2TemplateResult = (item) => {
  try {
    return initRoomBedsResult(item);
  } catch (e) {
    errorManager(e);
  }
};

window.IncontinenceProducts = {
  sizeSelect2TemplateResult: sizeSelect2TemplateResult,
};
